import { core } from '@tock/coretypes';
import AppConstants from 'constants/AppConstants';
import protos from 'utils/protos';

const { TockGiftCardOrderRequest, TockGiftCardRedeemRequest } = protos;

export function clearGiftCards(): BaseTockAction {
  return {
    type: AppConstants.TOCK_GIFT_CARD_CLEAR,
  };
}

export function purchaseTockGiftCard(request: core.ITockGiftCardOrderRequest): ApiAction {
  return {
    TockApi: {
      postProto: '/gift/card/tock/purchase',
      type: AppConstants.TOCK_GIFT_CARD_PURCHASE,
      request: TockGiftCardOrderRequest.fromObject(request),
    },
  };
}

export function redeemGiftCard(token: string): ApiAction {
  return {
    TockApi: {
      postProto: '/gift/card/tock/redeem',
      type: AppConstants.TOCK_GIFT_CARD_REDEEM,
      request: TockGiftCardRedeemRequest.fromObject({ token }),
    },
  };
}

// sending nothing checks balance for logged in user
export function checkTockGiftCardBalance(): ApiAction {
  return {
    TockApi: {
      postProto: '/gift/card/tock/balance',
      type: AppConstants.TOCK_GIFT_CARD_BALANCE,
    },
  };
}

export function fetchGiftCardPurchaseHistory(): ApiAction {
  return {
    TockApi: {
      getListProto: `/gift/card/purchase?count=1000`,
      type: AppConstants.TOCK_GIFT_CARD_PURCHASE_HISTORY,
    },
  };
}
